import { merge } from 'lodash/fp';

import { INSURANCE_SUB_TYPES } from '../constants';
import { InsuranceSubTypeValue, InsuranceTypeValue } from '../types';
import bali from './data/sub-pages/bali';
import car from './data/car';
import home from './data/home';
import newZealand from './data/sub-pages/new-zealand';
import travel from './data/travel';

const CONTENT = {
  car,
  home,
  travel,
};

const SUB_PAGE_CONTENT = {
  travel: {
    [INSURANCE_SUB_TYPES.BALI]: bali,
    [INSURANCE_SUB_TYPES.NEW_ZEALAND]: newZealand,
  },
};

type ContentData = keyof typeof CONTENT;
type SubPageContentData = keyof typeof SUB_PAGE_CONTENT;

export const getContent = (insuranceType: InsuranceTypeValue) => CONTENT[insuranceType as ContentData];

export const getSubPageContent = (insuranceType: InsuranceTypeValue, productOptionValue: InsuranceSubTypeValue) => {
  const parentInsuranceTypeContent = getContent(insuranceType);
  const subPageParentObject = SUB_PAGE_CONTENT[insuranceType as SubPageContentData];
  const subPageContent = subPageParentObject[productOptionValue];
  return merge(parentInsuranceTypeContent, subPageContent);
};
